import { render, staticRenderFns } from "./FixedBar.vue?vue&type=template&id=19648d8f&scoped=true&"
import script from "./FixedBar.vue?vue&type=script&lang=js&"
export * from "./FixedBar.vue?vue&type=script&lang=js&"
import style0 from "./FixedBar.vue?vue&type=style&index=0&id=19648d8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19648d8f",
  null
  
)

export default component.exports